// ToastManager.js
import React, { useState, createContext, useContext, useCallback } from 'react';
import ToastMessage from 'app/components/ToastMessage';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const showToast = useCallback((message, type = 'success') => {
    setToast({ show: true, message, type });
  }, []);

  const hideToast = useCallback(() => setToast({ ...toast, show: false }), [toast]);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
        <ToastMessage
          message={toast.message}
          type={toast.type}
          show={toast.show}
          onClose={hideToast}
        />
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
